import { apiClient } from "./client";
import { Planning } from "./planning";
import { Timesheet } from "./timesheets";
import { Photo } from "./photos";
import { Project } from "./projects";

export interface DashboardStats {
  hours_today: number;
  hours_week: number;
  hours_month: number;
  active_projects: number;
  photos_today: number;
  photos_week: number;
}

export interface DashboardData {
  stats: DashboardStats;
  todays_planning: Planning[];
  recent_timesheets: Timesheet[];
  recent_photos: Photo[];
  active_projects: Project[];
}

/**
 * Get dashboard data for the authenticated user
 */
export const getDashboard = async (): Promise<DashboardData> => {
  const { data } = await apiClient.get<{ data: DashboardData }>("/dashboard");
  return data.data;
};

/**
 * Get quick stats for the dashboard
 */
export const getDashboardStats = async (): Promise<DashboardStats> => {
  const { data } = await apiClient.get<{ data: DashboardStats }>(
    "/dashboard/stats"
  );
  return data.data;
};
